import { useEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import Text14 from '@sdk/components/ui/typography/Text14';
import Tooltip from '@sdk/common/tooltip/Tooltip';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import {
  TimeClockEntryWithDates,
  MaybeBreakAttestations,
} from '@web/timesheets/CreateTimesheetModal/createTimesheetModal.types';
import { useAutomatedBreaksSummary } from '@web/timesheets/CreateTimesheetModal/components/rows/DurationRow/durationRow.hooks';
import {
  Span,
  Div,
} from '@web/timesheets/CreateTimesheetModal/components/rows/DurationRow/automatedBreaksSummaryForTimesheet.styles';
import { ShiftWithLocationTimezone } from '@web/timeClock/ClockOutModal/clockOutModal.types';

const TOOLTIP_ID = 'create-timesheet-violated-break-tip';

type Props = {
  timeClockEntriesWithDates: TimeClockEntryWithDates[];
  breakAttestations?: MaybeBreakAttestations;
  shift?: ShiftWithLocationTimezone;
};

const AutomatedBreaksSummaryForTimesheet = ({
  timeClockEntriesWithDates,
  breakAttestations,
  shift,
}: Props) => {
  const summariesToDisplay = useAutomatedBreaksSummary(
    shift,
    timeClockEntriesWithDates,
    breakAttestations
  );

  useEffect(() => {
    ReactTooltip.rebuild();
  }, [summariesToDisplay]);

  return (
    <>
      {summariesToDisplay.map(([firstSummary, secondSummary], index) => {
        const ContainerTag = !index ? Span : Div;
        const isFirstIndex = !index;
        const isLastIndex = index === summariesToDisplay.length - 1;
        return (
          <ContainerTag key={index}>
            {isFirstIndex && <Text14 themeColor={ThemeColorType.gray}>&nbsp;·&nbsp;</Text14>}
            <Text14
              themeColor={firstSummary.themeColor}
              data-for={TOOLTIP_ID}
              data-tip={firstSummary.tipText}>
              {firstSummary.text}
            </Text14>
            {secondSummary && <Text14 themeColor={ThemeColorType.gray}>&nbsp;·&nbsp;</Text14>}
            {secondSummary && (
              <Text14
                themeColor={secondSummary.themeColor}
                data-for={TOOLTIP_ID}
                data-tip={secondSummary.tipText}>
                {secondSummary.text}
              </Text14>
            )}
            {!isLastIndex && <Text14 themeColor={ThemeColorType.gray}>&nbsp;·&nbsp;</Text14>}
          </ContainerTag>
        );
      })}

      <Tooltip id={TOOLTIP_ID} type="error" />
    </>
  );
};

export default AutomatedBreaksSummaryForTimesheet;
